import { errorHandler, databaseObjectService, instanceQueryService } from '@/services'

class TableService {
  async getTableGeneral(instanceId, table_id, database) {
    const tableGeneralSQL = `
      select
        t.table_id,
        t.name,
        t.schema_id,
        t.database_id,
        t.owner_id,
        t.distribution,
        k.sort_key,
        k.distribution_key,
        k.cluster_keys,
        k.partition_keys,
        t.is_temp,
        t.is_auto_analyze,
        t.auto_analyze_policy,
        t.last_analyzed,
        t.creation_time,
        t.rowstore_row_count,
        t.rowstore_bytes,
        d.name || '' as database_name,
        s.name || '' as schema_name,
        case
          when t.distribution = 'replicated' then
            stats.rows_columnstore_max + 0
          else
            stats.rows_columnstore_sum + 0
        end as rows_columnstore,
        case
          when t.distribution = 'replicated' then
            stats.compressed_bytes_max + 0
          else
            stats.compressed_bytes_sum + 0
        end as compressed_bytes,
        case
          when t.distribution = 'replicated' then
            stats.uncompressed_bytes_max + 0
          else
            stats.uncompressed_bytes_sum + 0
        end as uncompressed_bytes
      from sys.table t
      join sys.database d on d.database_id = t.database_id
      join sys.schema s on s.schema_id = t.schema_id and s.database_id = t.database_id
      left outer join (
        select *
        from sys.vt_table_keys_f($(table_id))
      ) k on k.table_id = t.table_id
      left outer join (
        select
          table_id,
          sum(rows_columnstore) as rows_columnstore_sum,
          max(rows_columnstore) as rows_columnstore_max,
          sum(compressed_bytes) as compressed_bytes_sum,
          max(compressed_bytes) as compressed_bytes_max,
          sum(uncompressed_bytes) as uncompressed_bytes_sum,
          max(uncompressed_bytes) as uncompressed_bytes_max
        from sys.table_storage
        where table_id = $(table_id)
        group by 1
      ) stats on stats.table_id = t.table_id
      where t.table_id = $(table_id)
    `
    try {
      const response = await instanceQueryService.sql(instanceId, database, tableGeneralSQL, { parameters: { table_id } })
      if (response.rows.length === 1) {
        const t = response.rows[0]
        /**
         * Legacy remapping from StorageManager
         */
        return {
          oid: t.table_id,
          databaseId: t.database_id,
          name: t.name,
          schemaId: t.schema_id,
          ownerId: t.owner_id,
          distributionType: t.distribution,
          sortKey: t.sort_key,
          distributionKey: t.distribution_key,
          clusterKeys: t.cluster_keys,
          partitionKeys: t.partition_keys,
          isTemp: t.is_temp,
          isAutoAnalyze: t.is_auto_analyze,
          autoAnalyzePolicy: t.auto_analyze_policy,
          lastAnalyzed: t.last_analyzed,
          creationTime: t.creation_time,
          database: t.database_name,
          schemaName: t.schema_name,
          rows: t.rows_columnstore,
          pendingRows: t.rowstore_row_count,
          pendingSize: t.rowstore_bytes,
          bytesUsed: t.compressed_bytes,
          bytesUsedUncompressed: t.uncompressed_bytes
        }
      } else {
        return null
      }
    } catch (e) {
      errorHandler.thrown(e, 'Could not retrieve information about this table.')
    }
  }

  async getTableDetails(instanceId, databaseName, schemaName, tableName) {
    try {
      return await databaseObjectService.getTableDefinition(instanceId, databaseName, schemaName, tableName)
    } catch (e) {
      errorHandler.thrown(e, 'Could not retrieve table details.')
    }
  }
}

export default new TableService()
